import { types as t } from 'mobx-state-tree';
import { AbstractTestSection } from '../../question-data-model/TestSection/abstract-test-section.store';
import { ResultTestQuestionGroupStore } from './result-test-question-group.store';

export const ResultTestSectionStore = AbstractTestSection.named('ResultTestSectionStore')
  .props({
    currentQuestionGroupIndex: t.optional(t.number, 0),
    questionGroups: t.array(ResultTestQuestionGroupStore),
  })
  .views((self) => ({
    getQuestions() {
      const questions = [];
      self.questionGroups.forEach((group: any) => {
        questions.push(...group.getQuestions());
      });
      return questions;
    },
    getQuestionsInGroup(groupIndex) {
      const selectedGroup: any = self.questionGroups.find(
        (group: any, index: number) => groupIndex === index
      );
      if (selectedGroup) {
        return [...selectedGroup.getQuestions()];
      }
      return [];
    },
  }));
